<script>
    import { ChevronDown } from 'lucide-svelte';

    export let question = '';
    export let answer = '';
    export let isOpen = false;

    function toggle() {
        isOpen = !isOpen;
    }
</script>

<div class="faq-item" itemscope itemtype="https://schema.org/Question">
    <button 
        class="faq-question" 
        onclick={toggle}
        aria-expanded={isOpen}
        aria-controls="faq-answer-{question.replace(/\s+/g, '-').toLowerCase()}"
    >
        <div class="chevron" class:rotated={isOpen}>
            <ChevronDown size={20} />
        </div>
        <h3 itemprop="name">{question}</h3>
    </button>
    
    <div 
        class="faq-answer" 
        class:open={isOpen}
        id="faq-answer-{question.replace(/\s+/g, '-').toLowerCase()}"
        itemscope 
        itemtype="https://schema.org/Answer"
    >
        <div class="faq-content" itemprop="text">
            {@html answer.split('\n').map(paragraph => `<p>${paragraph.trim()}</p>`).join('')}
        </div>
    </div>
</div>

<style>
    .faq-item {
        padding: 0;
        border-radius: 12px;
        overflow: hidden;
        transition: all 0.2s ease;
        width: 100%;
    }

    .faq-item:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .faq-question {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 0px;
        padding: 0px;
        padding-top: 16px;
        padding-bottom: 16px;
        background: none;
        border: none;
        cursor: pointer;
        text-align: left;
        transition: background-color 0.2s ease;
    }

    .faq-question:hover {
        background-color: #242424;
    }

    .faq-question h3 {
        margin: 0;
        font-size: 1.1rem;
        font-weight: 600;
        color: var(--surface);
        line-height: 1.4;
        font-family: var(--font-body);
        letter-spacing: -0.2px;
    }

    .chevron {
        flex-shrink: 0;
        color: var(--surface);
        transition: transform 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
    }

    .chevron.rotated {
        transform: rotate(180deg);
    }

    .faq-answer {
        display: grid;
        grid-template-rows: 0fr;
        overflow: hidden;
        transition: grid-template-rows 0.3s ease;
    }

    .faq-answer.open {
        grid-template-rows: 1fr;
    }

    .faq-content {
        min-height: 0;
        padding: 16px;
        color: var(--surface);
        line-height: 1.6;
        padding-left: 32px;
    }

    .faq-content :global(p) {
        margin: 0 0 1rem 0;
        color: var(--surface);
        opacity: 0.6;
        font-size: 16px;
    }

    .faq-content :global(p:last-child) {
        margin-bottom: 0;
    }

    .faq-content :global(ul) {
        margin: 0.5rem 0;
        padding-left: 1.5rem;
    }

    .faq-content :global(li) {
        margin-bottom: 0.5rem;
    }

    .faq-content :global(strong) {
        font-weight: 600;
    }

    .faq-content :global(a) {
        text-decoration: none;
    }

    .faq-content :global(a:hover) {
        text-decoration: underline;
    }

    /* Mobile optimizations */
    @media (max-width: 768px) {
        .faq-question {
            padding: 0rem;
            padding-top: 16px;
            padding-bottom: 16px;
        }

        .faq-question h3 {
            font-size: 1rem;
        }

        .faq-content {
            padding: 1.25rem;
        }

        .chevron {
            margin-left: 0;
        }
    }

    /* Accessibility improvements */
    .faq-question:focus {
    }

    .faq-question:focus-visible {
    }

    /* High contrast mode support */
    @media (prefers-contrast: high) {
        .faq-item {
            border-color: #000;
        }
        
        .faq-question h3 {
            color: #000;
        }
        
        .chevron {
            color: #000;
        }
    }

    /* Reduced motion support */
    @media (prefers-reduced-motion: reduce) {
        .faq-answer,
        .chevron {
            transition: none;
        }
        
        .faq-answer.open {
            max-height: none;
        }
    }
</style>